module.exports = __webpack_public_path__ + "static/media/Steps.8c2bb2d9.png";